import { render, staticRenderFns } from "./rInputBadge.vue?vue&type=template&id=f62d8f2c&scoped=true"
import script from "./rInputBadge.vue?vue&type=script&lang=js"
export * from "./rInputBadge.vue?vue&type=script&lang=js"
import style0 from "./rInputBadge.vue?vue&type=style&index=0&id=f62d8f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62d8f2c",
  null
  
)

export default component.exports